import SystemPropertyService from "../system-property/SystemPropertyService";
import {CREATION_TYPE_OPTIONS} from "../../../utils/loan-creation-helper";

class LoanTypesService {
    public getLoanCreationTypeOptions() {
        const loanCreationTypes = SystemPropertyService.getProperty('LOAN_CREATION_TYPES');
        if (!loanCreationTypes) {
            return CREATION_TYPE_OPTIONS;
        }
        const allowedTypes = loanCreationTypes.split(',');
        return CREATION_TYPE_OPTIONS.filter(option => allowedTypes.includes(option.value));
    }
}

export default new LoanTypesService();